import React, { useState, useEffect, useRef } from 'react'
import CustomSelectButton from './CustomSelectButton'
import useHttp from '../../../../hook/use-http';
import styles from './MileageSimulatorTab.module.css';

import * as $ from 'jquery';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";


function GlobalFilter(props) {
    const { filterData, setExpertInsightLoading, setGlobalFilter } = props;
    const [tableData, setTableData] = useState([])
    const [vinNo, setVinNumber] = useState([])
    const [regNo, setRegNumber] = useState([])
    const [selectedField, setSelectedField] = useState("VIN_NUM")


    const inputRefMSAnalysis = useRef(null);

    const { isLoading, error, sendReq: fetchData } = useHttp();
    const [modalData, setModalData] = useState({})

    const [filterData2, setFilterData2] = useState({ ...props.filterData })

    useEffect(() => {
        setFilterData2({ ...props.filterData })
    }, [filterData?.ROUTE, filterData?.CITY, filterData?.DEPO])

    useEffect(() => {
        setVinNumber([])
        setRegNumber([])
    }, [filterData?.CITY])

    const [filterdata, setFilterData] = useState({
        ...props.filterData,
        startDate: moment().subtract(7, 'days').format("YYYY-MM-DD"),
        endDate: moment().subtract(1, 'days').format("YYYY-MM-DD"),
    })

    const ApplyFilterFunction = (vinNo = [], regNo = []) => {
        if (selectedField == "VIN_NUM") {
            setGlobalFilter(prev => ({
                ...prev,
                startDate: filterdata?.startDate,
                endDate: filterdata?.endDate,
                VIN_NUM: vinNo,
                REG_NUM: []
            }))
        }
        if (selectedField == "REG_NUM") {
            setGlobalFilter(prev => ({
                ...prev,
                startDate: filterdata?.startDate,
                endDate: filterdata?.endDate,
                VIN_NUM: [],
                REG_NUM: regNo
            }))
        }
    }

    const updateFilter = (arr, index) => {
        setVinNumber([arr?.value])

    }
    const updateFilterForREGNo = (arr, index) => {
        setRegNumber([arr?.value])
    }

    const [clearFilters, setClearFilter] = useState(true)
    const clearFilter = () => {
        setRegNumber([])
        setVinNumber([])
        setClearFilter(!clearFilters)
        setGlobalFilter(prev => ({
            ...prev,
            startDate: '',
            endDate: "",
            VIN_NUM: [],
            REG_NUM: []
        }))
        setFilterData2([])
        setFilterData(prev => ({
            ...prev,
            startDate: moment().subtract(7, 'days').format("YYYY-MM-DD"),
            endDate: moment().subtract(1, 'days').format("YYYY-MM-DD"),
        }))
    }

    const formatDateForDisplay = (date) => {
        return date ? moment(date).format('MMM D, YYYY') : '';
    };


    useEffect(() => {
        if (filterdata?.startDate) {
            const today = moment();
            const fiveYearsAgo = moment().subtract(5, 'years');
            const defaultStart = moment(filterdata.startDate);
            const defaultEnd = moment(filterdata.endDate);

            $(inputRefMSAnalysis.current).daterangepicker(
                {
                    startDate: defaultStart,
                    endDate: defaultEnd,
                    minDate: fiveYearsAgo,
                    maxDate: today,
                    showDropdowns: true,
                    autoUpdateInput: false, // Disable auto input update
                    singleMonthMode: true,
                    linkedCalendars: false,
                    locale: {
                        format: 'MMMM D, YYYY',
                        applyLabel: 'Apply',
                        separator: ' - ',
                        cancelLabel: '',
                    },
                }
            );

            // Handle 'Apply' button click
            $(inputRefMSAnalysis.current).on('apply.daterangepicker', function (ev, picker) {
                const start = picker.startDate.format("YYYY-MM-DD");
                const end = picker.endDate.format("YYYY-MM-DD");

                $(this).val(
                    picker.startDate.format('MMMM D, YYYY') + ' - ' + picker.endDate.format('MMMM D, YYYY')
                );

                setFilterData(prev => ({
                    ...prev,
                    startDate: start,
                    endDate: end,
                }));
                // props.onsubmit(prev => ({
                //     ...prev,
                //     startDate: start,
                //     endDate: end,
                // }));
            });

            // Optional: clear input on cancel
            $(inputRefMSAnalysis.current).on('cancel.daterangepicker', function () {
                $(this).val('');
                setFilterData(prev => ({
                    ...prev,
                    startDate: null,
                    endDate: null,
                }));
            });
        }

        return () => {
            if ($(inputRefMSAnalysis.current).data('daterangepicker')) {
                $(inputRefMSAnalysis.current).data('daterangepicker').remove();
                $(inputRefMSAnalysis.current).off('.daterangepicker');
            }
        };
    }, []);

    return (
        <div>
            <div className={`col-lg-12 card py-3`}>
                <div className='d-flex'>
                    <div className="">
                        <select className={`form-select ${styles.filter_dropdown}`} value={selectedField} onChange={(e) => setSelectedField(e.target.value)}>
                            <option value="VIN_NUM">VIN No.</option>
                            <option value="REG_NUM">Reg. No.</option>
                        </select>
                    </div>
                    <div className="col-md-3">
                        {
                            selectedField == "VIN_NUM" ?
                                <CustomSelectButton apiEnd="simulator_vehicleId_filter" clearFilters={clearFilters} filterdata={filterData2} updateFilter={updateFilter} />
                                :
                                <CustomSelectButton apiEnd="simulator_vehicle_registration_number_filter" clearFilters={clearFilters} filterdata={filterData2} updateFilter={updateFilterForREGNo} />
                        }
                    </div>

                    {/* Wider Date Range */}
                    <div className="col-md-3">
                        <div className="input-group ">
                            <input
                                type="text"
                                ref={inputRefMSAnalysis}
                                className={`form-control ${styles.customDateRangePicker}`}
                                placeholder="Select date range"
                                value={
                                    filterdata.startDate && filterdata.endDate
                                        ? `${formatDateForDisplay(filterdata.startDate)} - ${formatDateForDisplay(filterdata.endDate)}`
                                        : ''
                                }
                                readOnly
                            />
                        </div>

                    </div>
                    <div className='d-flex  ms-auto'>
                        <button className={`btn btn-sm ms_btn me-2 active`} onClick={() => ApplyFilterFunction(vinNo, regNo)} >
                            Apply
                        </button>
                        <button className={`btn btn-sm ms_btn me-2`} onClick={() => clearFilter()}>
                            Clear filter
                        </button>

                    </div>
                </div>

            </div>
        </div>
    )
}

export default GlobalFilter
